import {
  Directive,
  ElementRef,
  Input,
  HostListener,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[rxContenteditablePlaceholder]',
})
export class ContenteditablePlaceholderDirective implements OnInit, OnDestroy {
  private placeholderVisible = false;
  private _placeholder = '';
  private _content = '';

  @Input() innerHTML: string = '';

  @Input()
  public set placeholder(value) {
    this._placeholder = value;
  }
  public get placeholder() {
    return this._placeholder;
  }

  constructor(
    private el: ElementRef,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {}

  ngOnDestroy(): void {}

  ngOnChanges(changes: SimpleChanges | any) {
    if (changes.innerHTML) {
      this._content = changes.innerHTML.currentValue || '';
      this.updatePlaceholderVisibility();
    }
  }

  @HostListener('input') onInput() {
    this.updatePlaceholderVisibility();
  }

  @HostListener('focus') onFocus() {
    this.updatePlaceholderVisibility();
  }

  @HostListener('blur') onBlur() {
    this.setPlaceholder();
  }

  private setPlaceholder(): void {
    if (!this.el.nativeElement.textContent.trim()) {
      this.el.nativeElement.textContent = this.placeholder;
      this.el.nativeElement.style.color = 'gray';
    }
    this.cd.detectChanges();
  }

  private updatePlaceholderVisibility(): void {
    const content = this._content.trim();
    if (content === '') {
      this.el.nativeElement.innerHTML = this.placeholder;
      this.el.nativeElement.style.color = 'gray';
    } else {
      this.el.nativeElement.innerHTML = this._content;
      this.el.nativeElement.style.color = 'black';
    }
  }
}
